import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTooth,
  faEyeSlash,
  faGlasses,
  faMagnet,
  faSun,
  faBandAid,
  faPiggyBank
} from "@fortawesome/free-solid-svg-icons";
// import { Button } from "react-bootstrap";

const title_background = require("../images/cloud_background.jpg");
const dr_madsen = require("../images/EHMadsen_web.jpg");
const gp_gc = require("../images/grandparents_grandkids.jpg");

const topics = [
  {
    icon: faMagnet,
    name: "Metal Braces",
    description:
      "Conventional metal bands, brackets and wires provide the most accurate control of smile shapes and tooth positions."
  },
  {
    icon: faGlasses,
    name: "Tooth-colored Braces",
    description:
      "Crystal materials provide the same precise treatment control as metal, and are less noticeable."
  },
  {
    icon: faEyeSlash,
    name: "Clear Custom Alignment Trays (CATS)",
    description:
      "A series of virtually invisible clear plastic trays can gradually straighten teeth to achieve a beautiful smile."
  },
  {
    icon: faBandAid,
    name: "Orthopedic Appliance",
    description:
      "An assortment of fixed metal and removable plastic appliances help the facial and jaw bones grow into the best positions."
  },
  {
    icon: faTooth,
    name: "Retainer",
    description:
      "We use a variety of retainers both to hold or make small adjustments to tooth positions."
  },
  {
    icon: faSun,
    name: "Whitening",
    description:
      "We offer custom bleaching trays and gel to whiten teeth. Many patients use our clear custom retainers as trays."
  }
];

export const Home = () => {
  return (
    <Container fluid className="content">
        <Row>
          <Col
            className="title"
            style={{
              backgroundImage: "url(" + title_background + ")"
            }}
          >
            <h1>Welcome to Brighter Smiles!</h1>
            <h3>Your Orthodontic Specialists</h3>
          </Col>
        </Row>
        <Row className="frame-row">
          <Col sm="1" md="2" lg="2" />
          <Col sm="10" md="4" lg="3" className="home-dr-madsen">
            <img src={dr_madsen} alt="Dr Madsen Working" />
          </Col>
          <Col sm="10" md="4" lg="5" className="home-dr-madsen-info">
            <p>
              Dr. Erik H. Madsen is a specialist in{" "}
              <em>dentofacial orthopedic treatment</em> and{" "}
              <em>orthodontic treatment</em>. Dentofacial orthopedic treatment
              adjusts the sizes and positions of the jaw bones which form the
              foundation of a great smile. Orthodontic treatment straightens the
              teeth.
            </p>
            <p>
              By combining both kinds of treatments, he can achieve the best
              appearance and long term results. He and his staff have been
              creating Brighter Smiles and beautiful faces for over 35 years, in
              Salt Lake City, Cottonwood Heights and Sandy, Utah. They treat
              children, teens, and adults.
            </p>
          </Col>
          <Col sm="1" md="2" lg="2" />
        </Row>
        <Row>
          <Container fluid className="alternate">
            <Row>
              <Col className="topicHeader">
                <h2>State of the Art Technology</h2>
                <p>
                  Combining technical excellence with friendly personalized
                  service is our specialty. We listen to you, teach you, and
                  help you to understand all aspects of your individualized
                  treatment plan and treatment process. If you have seen
                  something that you are interested in using for your treatment,
                  ask us about it!
                </p>
              </Col>
            </Row>
            <Row>
              {topics.map(topic => (
                <Col
                  key={topic.name}
                  sm="12"
                  md="6"
                  lg="4"
                  className="topicInfo"
                >
                  <FontAwesomeIcon icon={topic.icon} className="fa-2" />
                  <br />
                  {topic.name}
                  <p>{topic.description}</p>
                  {/* <Button className="topic-learn-more">Learn More</Button> */}
                </Col>
              ))}
            </Row>
          </Container>
        </Row>
        <Row className="frame-row">
          <Col sm={1} md={2} lg={2} />
          <Col sm={10} md={2} lg={2}>
            <h3>Contact us today for a free consultation!</h3>
          </Col>
          <Col sm={10} md={6} lg={6}>
            <p>
              There is no charge for your first visit, which includes{" "}
              <nobr>x-rays,</nobr> exam, and consultation. We will help you to
              understand the treatment options and decide on the best one for
              you.
            </p>
            <p>
              To schedule an initial consultation, call us at{" "}
              <a href="tel:801-94302700">(801)943-2700</a> or send us an email
              at{" "}
              <a href="mailto:reception@brightersmilesbraces.com?subject=Web%20Inquiry">
                {" "}
                reception@brightersmilesbraces.com
              </a>
              .
            </p>
          </Col>
          <Col sm={1} md={2} lg={2} />
        </Row>
        <Row className="alternate">
          <Container fluid>
            <Row>
              <Col sm="1" md="2" lg="2" />
              <Col sm="10" md="4" lg="5">
                <h2 className="light">
                  <FontAwesomeIcon icon={faPiggyBank} className="fa-2" />{" "}
                  Financing Available
                </h2>
                <p>
                  We will work with you to make your treatment affordable. We
                  accept most insurance plans and we offer a variety of
                  financing options.
                </p>
              </Col>
              <Col sm="10" md="4" lg="3">
                <img src={gp_gc} alt="Grand Parents and Grad Kids" />
              </Col>
              <Col sm="1" md="2" lg="2" rows />
            </Row>
          </Container>
        </Row>
      </Container>
  );
};
